import { authorizeApis } from '@/core/api';
import { $httpChangiRecommends } from '@/core/api';
import { setCookie } from '@/http/sharedStorage';
const userTokenKey = 'userToken';
const state = {
    isLoggedIn: !!localStorage.getItem(userTokenKey),
};
const mutations = {
    login(state, token) {
        state.isLoggedIn = true;
        localStorage.setItem(userTokenKey, token);
        // Whatever you were putting in localStorage:
        const payload = JSON.stringify({
            userToken: token,
        });
        // Put it in a cookie that all subdomains can read
        setCookie("shared_state_userToken", payload, {
            domain: process.env.VUE_APP_LOGIN_HOST.replace("login", "").replace("pre-prod-", ""),
            days: 1,
            secure: true,
            sameSite: "Lax",
            path: "/",
        });
    },
    logout(state) {
        state.isLoggedIn = false;
        localStorage.removeItem(userTokenKey);
    },
};
const actions = {
    async login({ commit, dispatch }, token) {
        //console.log('token', token);
        // Whatever you were putting in localStorage:
        const payload = JSON.stringify({
            userToken: token,
        });
        // Put it in a cookie that all subdomains can read
        setCookie("shared_state", payload, {
            domain: process.env.VUE_APP_LOGIN_HOST.replace("login", "").replace("pre-prod-", ""),
            days: 1,
            secure: true,
            sameSite: "Lax",
            path: "/",
        });
        authorizeApis(token);
        commit('login', token);
        try {
            const resp = await $httpChangiRecommends.api.getUserData();
            commit('userModule/setUser', resp.data.data, { root: true });
        }
        catch (error) {
            console.log(error);
            // keep your existing error shape, but guard in case it’s missing
            const status = error?.responseDetails?.status ??
                error?.response?.status;
            if (status === 401) {
                await dispatch('logout');
            }
        }
    },
    logout({ commit, dispatch }, token) {
        commit('logout');
        dispatch('checkoutModule/clearCheckoutData', null, { root: true });
        commit('userModule/resetUser', null, { root: true });
    },
    autoLogout({ commit }, token) {
        commit('logout');
        commit('userModule/resetUser', null, { root: true });
    },
    autoLogin({ dispatch }) {
        const token = localStorage.getItem(userTokenKey);
        if (!token) {
            dispatch('autoLogout');
            return;
        }
        dispatch('login', token);
    },
    getUserData({ commit, dispatch }) {
        $httpChangiRecommends.api
            .getUserData()
            .then((resp) => {
            commit('userModule/setUser', resp.data.data, { root: true });
        })
            .catch((error) => {
            console.log(error);
        });
    },
};
export const authModule = {
    state,
    mutations,
    actions,
    namespaced: true,
};
